// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textNavigate {
    font-size: inherit;
}

.textNavigate:hover {
    text-decoration: underline;
    cursor: pointer;
}

.textNavigate-disabled {
    cursor: default;
    pointer-events: none;
    text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/buttons/TextNavigate/TextNavigate.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,qBAAqB;AACzB","sourcesContent":[".textNavigate {\n    font-size: inherit;\n}\n\n.textNavigate:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.textNavigate-disabled {\n    cursor: default;\n    pointer-events: none;\n    text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
